import { darkTheme, Icon, lightTheme } from 'hfs-common-ui';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { setTheme as setThemeAction } from '~/components/containers/AppContainer/reducer';
import type { AppState } from '~/reducers';
import checkNodeEnvVariable from '~/utils/env-helpers/check-node-env-variable';

interface DispatchProps {
  setTheme: typeof setThemeAction;
}
export type Props = StateProps & DispatchProps;
export const DevScreenSizeIcon = ({ setTheme, isLightTheme }: Props) => {
  const handleOnClick = () => {
    if (isLightTheme) {
      setTheme({ theme: darkTheme, isLightTheme: false });
    } else {
      setTheme({ theme: lightTheme, isLightTheme: true });
    }
  };
  return (
    <div data-testid="devIconWrapper">
      {!checkNodeEnvVariable('production') && (
        <div className="MenuItem flex flex-row" onClick={handleOnClick} data-testid="themeIcon">
          <Icon type="action.bulb" />
          {['xs', 'sm', 'md', 'lg', 'xl'].map((e) => (
            <span key={e} className={`hidden ${e}:block`}>
              {e}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps: DispatchProps = { setTheme: setThemeAction };

function mapStateToProps({ app }: AppState) {
  const { isLightTheme } = app;
  return { isLightTheme };
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type StateProps = ConnectedProps<typeof connector>;
export default connector(DevScreenSizeIcon);
